<template>
  <div class="nav-item" v-if="data">
    <div class="wp_UserDp" v-if="profilePic">
      <img
        :src="profilePic"
        alt="profilePic"
        data-test="authenticatedUserModalImg1"
        id="authenticatedUserModalImg1"
      />
    </div>
    <div class="wp_UserDp" v-else>
      <img
        :src="$t(data.noProfilePictureImage)"
        alt="profilePic"
        data-test="authenticatedUserModalImg2"
        id="authenticatedUserModalImg2"
      />
    </div>
    <span id="username-welcome-span">
      <span
        class="text-capitalize wp_HeaderMenuItemsText"
        id="authenticatedUserModalSpan1-username-span"
        data-test="authenticatedUserModalSpan1"
      >{{getUserData.firstname?getUserData.firstname:'Guest'}}</span>
    </span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
	props: {
		data: {
			type: Object
		}
	},

	data () {
		return {

			profilePic: ''
		}
	},
	computed: {
		...mapGetters('user', [
			'getUserData',
			'getProfilePicture'
		])
	},
	mounted () {
		this.profilePic = this.getUserData.image_url
	},
	watch: {
		getUserData () {
			this.profilePic = this.getUserData.image_url
		}
	}
}
</script>
